var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card shadow-sm" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.notes,
            expression: "notes"
          }
        ],
        staticClass: "form-control",
        attrs: { rows: "29" },
        domProps: { value: _vm.notes },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.notes = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-block mt-3",
          on: { click: _vm.setPersonalNotes }
        },
        [
          _vm._v(
            "\n            " + _vm._s(_vm.$t("actions.save")) + "\n        "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }